import React from 'react';
import { Helmet } from 'react-helmet-async';

function CarInsurance() {
  return (
    <div className="w-full min-h-screen bg-gray-100 p-4">
      <Helmet>
        <title>Kota HOLDINGS - Car Insurance</title>
        <meta name="description" content="Get the best car insurance coverage with Kota Holdings." />
      </Helmet>
      <div className="mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
        <div className="bg-[#FF6F00] text-white p-6">
          <h2 className="text-2xl font-bold">We Provide the Best Value Car Insurance</h2>
          <p className="mt-2">Protect your vehicle with the best car insurance plans for financial security and peace of mind.</p>
          <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
            <input type="text" placeholder="Your Name" className="p-2 rounded-md text-black" />
            <input type="tel" placeholder="+91 Phone" className="p-2 rounded-md text-black" />
            <input type="email" placeholder="Email" className="p-2 rounded-md text-black" />
          </div>
          <textarea placeholder="Message" className="w-full mt-4 p-2 rounded-md text-black"></textarea>
          <button className="mt-4 bg-blue-600 hover:bg-blue-900 text-white px-6 py-2 rounded-md">Get Quote</button>
        </div>
        <div className="p-6">
          <h1 className="text-2xl md:text-3xl font-bold text-[#FF6F00] mb-4">What is Car Insurance?</h1>
          <p className="mb-4">Car insurance protects your vehicle from financial losses due to accidents, theft, and damages. It ensures you get the necessary financial support in case of unforeseen incidents.</p>
          <h2 className="text-xl font-bold mt-6 mb-2">Types of Car Insurance:</h2>
          <ul className="list-disc list-inside mb-4">
            <li><strong>Third-Party Insurance:</strong> Covers damages caused to other vehicles, property, or individuals.</li>
            <li><strong>Comprehensive Insurance:</strong> Covers damages to your own car, third-party liabilities, and theft.</li>
            <li><strong>Own Damage Insurance:</strong> Covers damages only to your own car due to accidents, natural disasters, and theft.</li>
            <li><strong>Zero Depreciation Cover:</strong> Ensures full claim without factoring depreciation of parts.</li>
            <li><strong>Personal Accident Cover:</strong> Provides compensation in case of accidental injury or death.</li>
          </ul>
          <h2 className="text-xl font-bold mt-6 mb-2">Important Terms in Car Insurance</h2>
          <ul className="list-disc list-inside mb-4">
            <li>Premium: The amount you pay for the policy.</li>
            <li>Policyholder: The person who owns the insurance policy.</li>
            <li>IDV (Insured Declared Value): The maximum sum insured for the car.</li>
            <li>Deductible: The amount the policyholder must pay before the insurance kicks in.</li>
            <li>No Claim Bonus (NCB): A discount for claim-free years.</li>
            <li>Cashless Claims: Repairs without upfront payment at network garages.</li>
            <li>Endorsements: Policy modifications or additions.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default CarInsurance;
